module.exports = __webpack_public_path__ + "img/characters120Off.635021bf.svg";